import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { PublishedConnectionColumns } from '~src/publishedConnectionTable/resources/PublishedConnectionColumns';
import { ContentTypeFilterClause, MixedContentItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionColumnContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getPublishedConnectionColumnInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const PublishedConnectionColumnDefinition: MixedContentItemDefinition = {
  itemType: 'virtualConnectionColumn',
  pluralName: Messages.publishedConnectionColumns,
  singularName: Messages.publishedConnectionColumn,
  emptyStateMessage: Messages.publishedConnectionColumnsEmpty,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnections,
  contentFilterKeys: PublishedConnectionColumnContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['virtualConnectionColumn']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return PublishedConnectionColumns.all().withExtraParams(PublishedConnectionColumnContentType.extraQueryParams);
  },
  fieldValueResourceType: 'virtualConnectionColumn',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionColumnInfos, contentList),
  supportedDisplayModes: ['list'],
};
